module.exports = __webpack_public_path__ + "fonts/Decimal-Thin.5bc6b3e.woff";